import { render, staticRenderFns } from "./TitleDetails.vue?vue&type=template&id=677272fd&scoped=true&"
import script from "./TitleDetails.vue?vue&type=script&lang=js&"
export * from "./TitleDetails.vue?vue&type=script&lang=js&"
import style0 from "./TitleDetails.vue?vue&type=style&index=0&id=677272fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677272fd",
  null
  
)

export default component.exports